function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "0%",
  y1: "0%",
  x2: "100%",
  y2: "100%",
  id: "A"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00baff",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#007cff",
  offset: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M26.9 20.233l-2.383-2.383a25.23 25.23 0 0 0 2.45-3.867L23.3 10.317a1.67 1.67 0 0 1-.417-1.7c.617-1.867.95-3.867.95-5.95A1.67 1.67 0 0 1 25.5 1h5.833A1.67 1.67 0 0 1 33 2.667C33 9.3 30.717 15.4 26.9 20.233zm-4.7 4.683A28.14 28.14 0 0 1 4.667 31 1.67 1.67 0 0 1 3 29.333v-5.817a1.67 1.67 0 0 1 1.667-1.667 19.01 19.01 0 0 0 5.95-.95c.583-.2 1.25-.05 1.7.4l3.667 3.667c1.35-.7 2.633-1.5 3.833-2.433l-19.5-19.5L2.683.683l30.633 30.65-2.35 2.35-8.767-8.767z",
  fill: "url(#A)",
  fillRule: "evenodd"
});

function SvgCallDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = React.forwardRef(SvgCallDisabled);
export default __webpack_public_path__ + "static/media/call-disabled.0c44eff9.svg";
export { ForwardRef as ReactComponent };